module.exports = __webpack_public_path__ + "media/newstyle/images/icon-check-red-94e42534efc4c7ec31d2cec79ff39c45.svg";